<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
     _/                                                                                                                    _/
     _/      事業者アカウントの編集画面(STDSC02C08)                                                                                   _/
     _/                                                                                                                    _/
     _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <div class="wrapper" ref="content">
    <a name="pagetop" id="pagetop" class="sr">ページの先頭</a>
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
            _/                                                                                                                    _/
            _/      税理士事務所共通ヘッダ                                                                                          _/
            _/                                                                                                                    _/
        _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <HeaderNav menuflg="1" />
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
               _/                                                                                                                    _/
               _/      画面定義                                                                                                      _/
               _/                                                                                                                    _/
        _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <div class="body">
      <div class="inner">
        <div class="pankuzu">
          <ul>
            <li>
              <router-link class="ico-home" :to="{ name: 'STFMFM01C01' }">メインページ</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'STDSDC02C01' }"
                >事業者情報</router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'STDSDC02C06' }"
                >事業者アカウント一覧</router-link
              >
            </li>
            <li>
              <span class="current">事業者アカウントの編集</span>
            </li>
          </ul>
        </div>
        <h1 class="h1">事業者アカウントの編集</h1>
        <h2 class="h2">
          {{ businessOperatorCode + "_" + businessOperatorName }}
        </h2>
        <!--
            ****  メッセージ表示領域 ****-->
        <p class="errMsg title-ico ico-warning" v-show="errors != ''">
          <ErrorMessage :errors="errors"></ErrorMessage>
        </p>
        <p class="lead">事業者アカウントを編集してください。</p>
        <p class="lead" id="outMessageArea">
          <font color="red" size="3rem"></font>
        </p>
        <!-- ******************************************************************
                   *  事業者アカウント情報                                          *
            ******************************************************************-->
        <div class="para">
          <h2 class="h3">事業者アカウント</h2>
          <p class="lead">
            アカウントを発行する利用者の情報を入力してください。
          </p>
          <p class="sup-explanation">
            入力されたメールアドレスは、事業者への各通知の宛先の初期値として設定されます。
          </p>
          <br />
          <div class="criteria">
            <div class="frm-row">
              <span class="frm-label w-150px">
                <strong>事業者ID</strong>
              </span>
              <span class="frm-label w-150px">
                <p>{{ tatsuzinBopId }}</p>
              </span>
            </div>
            <div class="frm-row">
              <span class="frm-label w-150px">
                <strong>利用者名</strong>
              </span>
              <input
                tabindex="1"
                class="frm-text frm-size-l"
                type="text"
                ref="textInputBopUserName"
                maxlength="50"
                v-model="bopUserName"
                v-bind:class="{ error: isErrorBopUserName }"
              />
            </div>
            <p
              class="errMsg"
              style="margin-left: 160px"
              v-show="errors_bopusername != ''"
            >
              <ErrorMessageCase :errors="errors_bopusername"></ErrorMessageCase>
            </p>
            <div class="frm-row">
              <span class="frm-label w-150px">
                <strong>メールアドレス</strong>
              </span>
              <input
                tabindex="2"
                class="frm-text frm-size-xl"
                title=" "
                type="url"
                maxlength="255"
                v-model="emailAddress"
                v-bind:class="{ error: isErrorEMailAddress }"
              />
            </div>
            <p
              class="errMsg"
              style="margin-left: 160px"
              v-show="errors_emailaddress != ''"
            >
              <ErrorMessageCase
                :errors="errors_emailaddress"
              ></ErrorMessageCase>
            </p>
          </div>
        </div>
        <br />
        <br />
        <!-- ******************************************************************
                   *  事業者アカウント通知に関する設定                              *
            ******************************************************************-->
        <div class="para">
          <h2 class="h3">当アカウントに対する処理</h2>
          <div class="criteria">
            <div class="frm-row">
              <span class="frm-label w-150px">
                <strong>アカウントロック</strong>
              </span>
              <div
                tabindex="3"
                class="frm-toggle frm-size-m"
                @keydown.left.stop.prevent="
                  toggleRadio(
                    'rdoAccountLockDivision',
                    DivisionArray.map((e) => e.code)
                  )
                "
                @keydown.right.stop.prevent="
                  toggleRadio(
                    'rdoAccountLockDivision',
                    DivisionArray.map((e) => e.code)
                  )
                "
              >
                <label v-for="item in DivisionArray" :key="item.code">
                  <input
                    type="radio"
                    :value="item.code"
                    name="rdoAccountLockDivision"
                    v-model="rdoAccountLockDivision"
                  />
                  <span>{{ item.name }}</span>
                </label>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
      <!-- ******************************************************************
               *  下部ボタン群                                                  *
          ******************************************************************-->
      <div class="frm-btn-row footer-btn">
        <div class="frm-item grow center">
          <button
            tabindex="5"
            class="frm-btn strong large"
            type="button"
            @click="handleAdd"
          >
            確定
          </button>
          <button
            tabindex="6"
            class="frm-btn large"
            type="button"
            @click="cancleBtn"
          >
            キャンセル
          </button>
        </div>
      </div>
    </div>
    <ProcessingCompleteModal></ProcessingCompleteModal>
  </div>
  <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
            _/                                                                                                                    _/
            _/      ダイアログ定義：前画面へ戻る際の確認ダイアログ                                                                _/
            _/                                                                                                                    _/
      _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
  <ConfirmDialog
    :isShow="isShow"
    :message="content"
    @confirm="confirm"
    @cancel="cancel"
  ></ConfirmDialog>
</template>
<!-- ********************************
             *******  スクリプト定義  *******
             ******************************** -->
<script>
import { mapMutations, mapActions } from "vuex";
import moment from "moment";
import HeaderNav from "@/components/AccountingHeader.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import ErrorMessageCase from "@/components/ErrorMessageCase.vue";
import ProcessingCompleteModal from "@/components/STDSDC01C04ProcessingCompleteModal.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { EDIT_DIVISION_LIST } from "@/util/data.js";
import Validation from "@/util/validation.js";
import Common from "@/util/common.js";
import {
  API_DisplayBopAccountManageScreen,
  API_UpdateBopAccount,
} from "@/api/Modules/DC02/STDSDC02C08.js";
import { API_BopDataUnlock } from "@/api/Modules/CM04/STDSCM04C00.js";
export default {
  name: "STDSDC02C06",
  components: {
    HeaderNav,
    ErrorMessage,
    ErrorMessageCase,
    ProcessingCompleteModal,
    ConfirmDialog,
  },
  data() {
    return {
      errors: [],
      errors_bopusername: [],
      errors_emailaddress: [],
      tatsuzinBopId: "",
      bopUserName: "",
      emailAddress: "",
      emailAddressCopy: "",
      notifyStatus: 99,
      isErrorBopUserName: false,
      isErrorEMailAddress: false,
      rdoAccountLockDivision: 2,
      businessOperatorId: 0,
      businessOperatorCode: "",
      businessOperatorName: "",
      bopUserInfoDetail: {},
      isShow: false, // 遷移提示表示
      content: "", // メッセージ
      toRouter: "", // 遷移先画面
      updateParam: {
        bopUserInfoDetail: {},
        businessOperatorId: 0,
        sendFlg: false,
        subject: "",
        body: "",
        bodySignature: "",
      },
    };
  },
  created() {
    // 画面遷移チェック用メッセージ初期化
    this.content = Common.getMessage("MTCL2001", []);
  },
  mounted() {
    // 初期フォーカス設定(事業者コード)
    this.$nextTick(() => this.$refs.textInputBopUserName.focus());

    // 「処理中」表示
    this.processDialogue(true);
    API_DisplayBopAccountManageScreen().then((response) => {
      if (response.result == "0000") {
        this.businessOperatorId = response.businessOperatorId;
        this.businessOperatorCode = response.businessOperatorCode;
        this.businessOperatorName = response.businessOperatorName;
        this.tatsuzinBopId = response.tatsuzinBopId;
        this.bopUserName = response.bopUserName;
        this.emailAddress = response.emailAddress;
        this.emailAddressCopy = response.emailAddress;
        this.notifyStatus = response.notifyStatus;
        this.accountLocked = response.accountLocked;

        if (this.accountLocked == true) {
          this.rdoAccountLockDivision = 1;
        } else {
          this.rdoAccountLockDivision = 2;
        }
      } else {
        // エラー表示
        this.errors.push(
          Common.createError(
            response.errorCD,
            Common.getMessage(response.errorCD, [])
          )
        );
      }
    });
    this.processDialogue(false);
  },
  beforeRouteLeave(to, from, next) {
    // 画面遷移チェック
    if (
      !this.$cookies.get("SessionID") ||
      to.name == "STDSCM04C06" ||
      this.toRouter
    ) {
      if (!this.$cookies.get("SessionID") || to.name == "STDSCM04C06") {
        next();
      } else {
        const param = {
          BusinessOperatorId: this.businessOperatorId,
        };
        API_BopDataUnlock(param).then((response) => {
          if (response.errorCD) {
            this.errors = [];
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          } else {
            next();
          }
        });
      }
    } else {
      this.toRouter = to;
      this.isShow = true;
    }
  },
  computed: {
    // パスワード再発行/アカウントロックの設定
    DivisionArray() {
      return EDIT_DIVISION_LIST.filter((el) => el.code != 0);
    },
  },
  methods: {
    ...mapMutations("businessModule", ["processDialogue"]),
    ...mapActions("businessModule", ["showProcessDialogue"]),
    ...mapActions("businessModule", ["completeDialogue"]),
    confirm() {
      // 遷移チェック：「OK」
      this.isShow = false;
      this.$redirect(this.toRouter);
    },
    cancel() {
      // 遷移チェック：「キャンセル」
      this.isShow = false;
      this.toRouter = "";
    },
    // アカウント発行ボタン押下
    handleAdd() {
      // エラースタイルを初期化する
      this.errorStyleInit();
      // エラー情報の初期化
      this.errors = [];
      this.errors_bopusername = [];
      this.errors_emailaddress = [];

      // 利用者名
      // 必須チェック
      if (!this.bopUserName && this.bopUserName !== 0) {
        this.isErrorBopUserName = true;
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
          );
        }
        if (!this.errors_bopusername || this.errors_bopusername.length == 0) {
          this.errors_bopusername.push(
            Common.createError(
              "MTCL1001",
              Common.getMessage("MTCL1001", ["利用者名"])
            )
          );
        }
      }
      // 入力の場合
      else {
        // 禁則文字チェック
        if (!Validation.checkNationalkinsokuchar(this.bopUserName)) {
          this.isErrorBopUserName = true;
          if (!this.errors || this.errors.length == 0) {
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
          }
          if (!this.errors_bopusername || this.errors_bopusername.length == 0) {
            this.errors_bopusername.push(
              Common.createError(
                "MTCL1098",
                Common.getMessage("MTCL1098", ["利用者名"])
              )
            );
          }
        }
      }
      // メールアドレス
      // 必須チェック
      if (!this.emailAddress && this.emailAddress !== 0) {
        this.isErrorEMailAddress = true;
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
          );
        }
        if (!this.errors_emailaddress || this.errors_emailaddress.length == 0) {
          this.errors_emailaddress.push(
            Common.createError(
              "MTCL1001",
              Common.getMessage("MTCL1001", ["メールアドレス"])
            )
          );
        }
        // メールアドレスチェック
      } else if (this.emailAddress && !Validation.isMail(this.emailAddress)) {
        this.isErrorEMailAddress = true;
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
          );
        }
        if (!this.errors_emailaddress || this.errors_emailaddress.length == 0) {
          this.errors_emailaddress.push(
            Common.createError(
              "MTCL1015",
              Common.getMessage("MTCL1015", ["メールアドレス"])
            )
          );
        }
      }

      if (this.isErrorBopUserName == true || this.isErrorEMailAddress == true) {
        return;
      }

      var lockFlg = false;
      if (this.rdoAccountLockDivision == 1) {
        lockFlg = true;
      }

      // 設定するパラメータ(事業者ユーザー情報詳細);
      this.bopUserInfoDetail = {
        tatsuzinBopId: this.tatsuzinBopId,
        bopUserName: this.bopUserName,
        emailAddress: this.emailAddress,
        notifyStatus: this.notifyStatus,
        accountLocked: lockFlg,
      };

      this.updateParam = {
        bopUserInfoDetail: this.bopUserInfoDetail,
        businessOperatorId: this.businessOperatorId,
      };

      // 「処理中」表示
      this.processDialogue(true);

      // /事業者情報クラスを利用して、事業者アカウントを発行する。
      API_UpdateBopAccount(this.updateParam).then((response) => {
        // 「処理中」非表示
        this.processDialogue(false);
        if (_.eq(response.result, "0000")) {
          //処理完了画面からの遷移先は、事業者アカウント一覧画面(STDSDC02C06)。]
          this.toRouter = "STDSDC02C06";
          this.$router.push({
            name: "STDSDC02C06",
          });
        } else {
          // エラー表示
          if (response.errorMSG) {
            this.errors.push(
              Common.createError(response.errorCD, response.errorMSG)
            );
          } else {
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }          
        }
      });
    },
    toggleRadio(keyName, list) {
      this[keyName] = this[keyName] == list[0] ? list[1] : list[0];
    },    
    cancleBtn() {
      this.toRouter = "";
      this.$router.push({
        name: "STDSDC02C06",
      });
    },

    // エラースタイルを初期化する
    errorStyleInit() {
      this.isErrorBopUserName = false;
      this.isErrorEMailAddress = false;
    },
    // パスワード生成
    generatePassword(id, length) {
      const letters = "abcdefghijklmnopqrstuvwxyz";
      const numbers = "0123456789";
      const str = letters + letters.toUpperCase() + numbers;
      var password = "";
      var i = 0;
      while (i < length) {
        password += str.charAt(Math.floor(Math.random() * str.length));
        i++;
        // パスワードが不正な場合、パスワードを再生成
        if (password.length == length && !Validation.isPassword(id, password)) {
          i = 0;
          password = "";
        }
      }
      return password;
    },
  },
};
</script>
<style scoped>
.body {
  padding: 0 0 30px;
}
</style>